module.exports = __webpack_public_path__ + "static/bg_enquiry.28437381.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg_enquiry.jpg
// module id = 1182
// module chunks = 223049868600526